import $ from 'jquery';
import './themes/footer/_footer';
import './themes/slider-marquee/_slider-marquee';
import './themes/homepage/_homepage';